const experiments = {
    'yaeM1e9rTOaaajJ3Ql6-ow': 'compare-bar'
}

function checkForGoogleOptimize() {
    if (window.google_optimize !== undefined) {
        document.body.classList.add('go-active');

        Object.keys(experiments).forEach(key => {
            const experimentFound = window.google_optimize.get(key);
            if (!experimentFound) return;
            const state = window.google_optimize.get(key) === '1' ? 'active' : 'inactive';
            document.body.classList.add(`go-${experiments[key]}-${state}`)
        })
    } else {
        setTimeout(checkForGoogleOptimize, 100);
    }
}

export default (() => {
    checkForGoogleOptimize();
})();
